import styled from 'styled-components'

export const Container404 = styled.div`
	font-weight: 800;
	font-size: 20px;
	width: 100%;
	text-align: center;
	margin-top: 64px;
`
